export default __webpack_public_path__ + "static/media/11t.ca5dbb51.jpg";